export enum EnterPromocodeResult {
  Success,
  NotFound,
  UsedOther,
  Conflict
}
